import classNames from "classnames";
import moment from "moment";
import React from "react";
import {
	EORB3RecordState,
	TORB3BackendRecord,
	TORB3Record,
} from "../../../../../redux/app/orb3/@types";
import { TORB3GroupF2 } from "../../../../../redux/app/orb3/groups/group-f";
import ORB3TableRows, { ORB3TableColumns } from "../ORB3TableRows";
import ORB3Previewer from "../ORB3Previewer";
import { marpolUtils } from "redux/app/marpol";

type OwnProps = {
	orb3Record: TORB3Record | TORB3BackendRecord;
	isStrikedOff?: boolean;
	theme?: "light" | "dark";
};
type ORB3GroupF2PreviewProps = OwnProps;

function ORB3GroupF2Preview(props: ORB3GroupF2PreviewProps) {
	const record = props.orb3Record as TORB3GroupF2;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY",
	);
	const dateOfOriginalOperation = moment(
		record.itemF2P1.dateOfOriginalOperation,
		"YYYY-MM-DD",
	).format("DD-MMM-YYYY");
	const userTheme = localStorage.getItem("theme") || "light";
	const resolvedTheme = props.theme ?? userTheme;

	function renderMain() {
		return (
			<>
				<ORB3TableRows
					record={record}
					tableRows={[
						[dateOfOriginalOperation, "3-F", "-", renderItemF2P1()],
						[...renderMissedPlaceholder()],
						[null, null, "NOTE", record.remarks],
					]}
					theme={props.theme}
				/>
				{renderMissedRecord()}
			</>
		);
	}

	function renderItemF2P1() {
		return (
			<h4 className="font-medium uppercase">
				Entry pertaining to an earlier missed operational entry
				{record.itemF2P1.receiptAttachment &&
				record.itemF2P1.receiptAttachment !== " " ? (
					<>
						<br />
						Correction Note:{" "}
						<a
							href={marpolUtils.getAttachmentURL(
								record.itemF2P1.receiptAttachment,
								record.id,
								record._rev,
							)}
							download={record.itemF2P1.receiptAttachment}
						>
							{" "}
							{record.itemF2P1.receiptAttachment}
						</a>
					</>
				) : null}
			</h4>
		);
	}

	function renderMissedPlaceholder(): ORB3TableColumns {
		const canShowPlaceholder =
			record.itemF2P1.isAnMissedEntryRecord && !record.itemF2P1.missedRecord;
		if (!canShowPlaceholder) return [null, null, null, null];

		const content = (
			<h4 className="font-medium text-gray-500 uppercase">
				<div
					className={classNames(
						"flex flex-row items-center justify-center p-6 px-12 font-medium text-center border-2 border-dashed",
						{
							"bg-gray-100 border-gray-400": resolvedTheme === "light",
							"bg-backgroundSenary border-ws_input_border":
								resolvedTheme === "dark",
						},
					)}
				>
					<div>MISSED ENTRY WILL APPEAR HERE</div>
					<span className="ml-6 text-gray-400 bp3-icon bp3-icon-time" />
				</div>
			</h4>
		);

		return [
			operationDate,
			<div className="text-gray-500">?</div>,
			<div className="text-gray-500">?</div>,
			content,
		];
	}

	function renderMissedRecord() {
		if (!record.itemF2P1.missedRecord) return null;
		return (
			<ORB3Previewer
				record={{
					...record.itemF2P1.missedRecord,
					selectedDate: record.selectedDate,
					state: props.isStrikedOff
						? EORB3RecordState.STRIKED_OFF
						: record.itemF2P1.missedRecord.state,
				}}
			/>
		);
	}

	return renderMain();
}

export default ORB3GroupF2Preview;
